import classNames from 'classnames';

import styles from './Headlines.module.scss';

const Headlines = ({
    headline,
    subHeadline,
}: {
    readonly headline?: string;
    readonly subHeadline?: string;
}): JSX.Element => {
    return (
        <>
            {headline && (
                <h1
                    className={classNames(styles.headline, 'text-xs-center mt-6x', {
                        'mb-4x': !subHeadline,
                        'mb-1x': !!subHeadline,
                    })}
                >
                    {headline}
                </h1>
            )}
            {subHeadline && (
                <p className={classNames(styles.subHeadline, 'text-xs-center')}>{subHeadline}</p>
            )}
        </>
    );
};

export { Headlines };
